import { TFunction } from 'react-i18next'
import { WalletsCreateRequest } from 'types/wallets'
import * as yup from 'yup'
export const createWalletSchema = (t: TFunction<'translation', undefined>) => {
  return yup.object<Partial<Record<keyof WalletsCreateRequest, yup.AnySchema>>>({
    currency: yup.string().required(),
    description: yup.string().required(t('walletNameRequired')).max(40, t('walletNameLengthError')),
  })
}
